import moment from 'moment';
var isDateAfter = function (format) {
    if (format === void 0) { format = 'DD.MM.YYYY'; }
    return function (value) {
        return moment(value, format, true).isAfter();
    };
};
export default isDateAfter;
